import fetchWithMethod from "@/src/utils/fetchWithMethod";
import axios from "axios";

export async function selectPlan(plan_id) {
  const url = `/api/billing/plans/${plan_id}/select`;
  const { data: plan, error } = await fetchWithMethod({
    method: "GET",
    url: url,
    headers: {
      "content-Type": "application/json",
    },
    // data: JSON.stringify(data),
    credentials: "include",
  });
  const loading = !plan && !error;
  const unauthorized = error && error.status === 401;

  return {
    loading,
    unauthorized,
    plan,
    error,
  };
}

export async function createMethod(data) {
  const url = `/api/billing/methods`;
  const { data: method, error } = await fetchWithMethod({
    method: "POST",
    url: url,
    headers: {
      "content-Type": "application/json",
    },
    data,
    credentials: "include",
  });
  const loading = !method && !error;
  const unauthorized = error && error.status === 401;

  return {
    loading,
    unauthorized,
    method,
    error,
  };
}
export async function createPayment(data) {
  const formData = new FormData();
  formData.append("payment_proof", data.payment_proof);
  if (data.scheduled_subscription !== undefined) {
    formData.append("scheduled_subscription", JSON.stringify(data.scheduled_subscription));
  } else {
    formData.append("subscription", JSON.stringify(data.subscription));
  }
  const url = `/api/billing/payments`;
  const { data: payment, error } = await fetchWithMethod({
    method: "POST",
    url: url,
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
    credentials: "include",
  });
  const loading = !payment && !error;
  const unauthorized = error && error.status === 401;
  //   return response;
  return {
    loading,
    unauthorized,
    payment,
    error,
  };
}
export async function createSubscription(data) {
  const url = `/api/billing/subscriptions`;
  const { data: subscription, error } = await fetchWithMethod({
    method: "POST",
    url: url,
    headers: {
      "content-Type": "application/json",
    },
    data,
    credentials: "include",
  });
  const loading = !subscription && !error;
  const unauthorized = error && error.status === 401;

  return {
    loading,
    unauthorized,
    subscription,
    error,
  };
}

export async function updateSubscription(data,id) {
  const url = `/api/billing/subscriptions/${id}`;
  const { data: subscription, error } = await fetchWithMethod({
    method: "PATCH",
    url: url,
    headers: {
      "content-Type": "application/json",
    },
    data,
    credentials: "include",
  });
  const loading = !subscription && !error;
  const unauthorized = error && error.status === 401;

  return {
    loading,
    unauthorized,
    subscription,
    error,
  };
}


export async function upgradeSubscription(data,id) {
  const url = `/api/billing/subscriptions/${id}/upgrade/`;
  const { data: subscription, error,status } = await fetchWithMethod({
    method: "PATCH",
    url: url,
    headers: {
      "content-Type": "application/json",
    },
    data,
    credentials: "include",
  });
  const loading = !subscription && !error;
  const unauthorized = error && error.status === 401;
  return {
    loading,
    unauthorized,
    subscription,
    error,
  };
}

// ─── Scheduled Subscriptions ────────────────────────────────────────────────

export async function createScheduledSubscription(data) {
  const url = `/api/billing/scheduled-subscriptions`;
  console.log("[createScheduledSubscription] payload envoyé:", data);
  const { data: subscription, error } = await fetchWithMethod({
    method: "POST",
    url,
    headers: { "content-Type": "application/json" },
    data,
    credentials: "include",
  });
  console.log("[createScheduledSubscription] réponse:", { subscription, error });
  const loading = !subscription && !error;
  const unauthorized = error && error.status === 401;
  return { loading, unauthorized, subscription, error };
}

export async function updateScheduledSubscription(data, id) {
  const url = `/api/billing/scheduled-subscriptions/${id}`;
  const { data: subscription, error } = await fetchWithMethod({
    method: "PATCH",
    url,
    headers: { "content-Type": "application/json" },
    data,
    credentials: "include",
  });
  const loading = !subscription && !error;
  const unauthorized = error && error.status === 401;
  return { loading, unauthorized, subscription, error };
}

export async function upgradeScheduledSubscription(data, id) {
  const url = `/api/billing/scheduled-subscriptions/${id}/upgrade/`;
  const { data: subscription, error } = await fetchWithMethod({
    method: "PATCH",
    url,
    headers: { "content-Type": "application/json" },
    data,
    credentials: "include",
  });
  const loading = !subscription && !error;
  const unauthorized = error && error.status === 401;
  return { loading, unauthorized, subscription, error };
}
